import { cn } from "@/utils/cn";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface LogoProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  variant?: "icon" | "horizontal" | "vertical";
  theme?: "color" | "white" | "auto";
  asLink?: boolean;
  className?: string;
}

const sizeMap = {
  xs: "h-6",
  sm: "h-8",
  md: "h-10",
  lg: "h-16",
  xl: "h-24",
};

export default function Logo({
  size = "md",
  variant = "horizontal",
  theme = "color",
  asLink = true,
  className,
}: LogoProps) {
  const { i18n } = useTranslation();
  const homePath = `/${i18n.language}/`;

  if (theme === "auto") {
    return (
      <>
        <Logo
          size={size}
          variant={variant}
          theme="color"
          asLink={asLink}
          className={cn("dark:hidden", className)}
        />
        <Logo
          size={size}
          variant={variant}
          theme="white"
          asLink={asLink}
          className={cn("hidden dark:block", className)}
        />
      </>
    );
  }

  const heightClass = sizeMap[size];

  const content = (
    <img
      src={`/logos/${variant}-${theme}.svg`}
      alt="ANDAR"
      className={cn("object-contain", heightClass, className)}
    />
  );

  if (!asLink) return content;

  return (
    <Link to={homePath} aria-label="ANDAR - Home" className="inline-block shrink-0">
      {content}
    </Link>
  );
}
